import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import styles from "./style.module.css";

export interface IGridData {
  label: string;
  value: string;
}

interface Props {
  title?: string;
  list?: IGridData[];
  onClick?: (value: string[]) => void;
  column: number;
  selectedValue?: string[];
  setValue?: (value: string[]) => void;
  selectType: "multi" | "single";
}

export default function GridList({
  title,
  list,
  column,
  onClick,
  selectedValue,
  setValue,
  selectType,
}: Props) {
  const [select, setSelect] = useState<string[]>(selectedValue || []);
  const handleSelectMultiItem = (item: string) => {
    if (title && title.includes("년")) {
      if (select.includes(item)) {
        setSelect((prevState) => prevState.filter((value) => value !== item));
      } else if (select.length >= 3) {
        toast.error("3개까지 선택 가능합니다.");
      } else {
        setSelect((prevState) => [...prevState, item]);
      }
    } else if (select.includes(item)) {
      setSelect((prevState) => prevState.filter((value) => value !== item));
    } else {
      setSelect((prevState) => [...prevState, item]);
    }
  };

  const handleSelectSingleItem = (item: string) => {
    if (select.includes(item)) {
      setSelect([]);
    } else {
      setSelect([item]);
    }
  };

  useEffect(() => {
    setValue?.(select);
  }, [select]);

  useEffect(() => {
    if (setValue && selectedValue) {
      setSelect(selectedValue);
    }
  }, [selectedValue]);

  return (
    <div className={styles.wrap}>
      {title && <p className={styles.title}>{title}</p>}
      <div
        className={styles.list}
        style={{ gridTemplateColumns: `repeat(${column}, 1fr)` }}
      >
        {(list || []).map((item, key) => {
          return (
            <button
              key={key}
              type="button"
              className={
                selectedValue?.includes(item.value) ? styles.selectedItem : ""
              }
              onClick={() =>
                selectType === "multi"
                  ? handleSelectMultiItem(item.value)
                  : handleSelectSingleItem(item.value)
              }
            >
              {item.label}
            </button>
          );
        })}
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </div>
  );
}
